export const getDocCompanyInfoInitialValues = () => ['• XXX, CEO of XXX, CEO since YYY']
